import userSlice, { UserState as UserStateType } from "./userSlice";
import logicActions from "./logicActions";

const { actions, reducer, selectors } = userSlice;
const combinedActions = {
  ...logicActions,
  ...actions,
};

export { combinedActions as actions, reducer, selectors };
export type UserState = UserStateType;

export { default as userLogic } from "./userLogic";
